import { Outlet } from "react-router-dom";
import { useAuditAuthenticatedView } from "services/coreapi";
import { ChatStoreProvider } from "src/stores/ChatStoreProvider";
import { AppLayout } from "./AppLayout";

export function AuthenticatedLayout() {
  // RouteGuard only lets this layout render for a signed-in, subscribed,
  // onboarded user — so mounting it is "the user saw the authenticated app".
  useAuditAuthenticatedView();

  return (
    <ChatStoreProvider>
      <AppLayout>
        <div data-testid="authenticated-view" style={{ display: "contents" }}>
          <Outlet />
        </div>
      </AppLayout>
    </ChatStoreProvider>
  );
}
